
import { Component, Watch } from 'vue-property-decorator';
import { LoadingOverlayHelper } from '@/helpers/LoadingOverlayHelper';
import { RouteNames } from '@/enums/routes/RouteNames';
import { CmsEntityTypes } from '@/enums/global/CmsEntityTypes';
import { NewRouteConfiguration } from '@/interfaces/components/cms/NewRouteConfiguration';
import { generateGivenEntityData, openEntityIndex, setRouteEntity } from '@/helpers/CmsShowHelper';
import SettingsTopBar from '@/components/views/settings/SettingsTopBar.vue';
import CmsUserTable from '@/components/views/CmsShow/CmsUserTable.vue';
import CmsCommercialistTable from '@/components/views/CmsShow/CmsCommercialistTable.vue';
import CmsB2BGroupsActivityTable from '@/components/views/CmsShow/CmsB2BGroupsActivityTable.vue';
import UserRightsTable from '@/components/views/CmsShow/UserRightsTable.vue';
import CmsProtectedClientsTable from '@/components/views/CmsShow/CmsProtectedClientsTable.vue';
import { EventBusEvents } from '@/enums/global/EventBusEvents';
import { EventBus } from '@/helpers/EventBusHelper';
import { UserRightsMixin } from '@/mixins/UserRights';
import { mixins } from 'vue-class-component';
import NotAllowedComponent from '../components/views/settings/NotAllowedComponent.vue';
import UserGroup from '@/models/UserGroup';
import UserGroupRepository from '@/repositories/UserGroupRepository';

@Component({
    name: 'CmsUsers',
    components: {
        CmsUserTable,
        CmsCommercialistTable,
        CmsB2BGroupsActivityTable,
        SettingsTopBar,
        NotAllowedComponent,
        UserRightsTable,
        CmsProtectedClientsTable,
    },
})
export default class CmsUsers extends mixins<UserRightsMixin>(UserRightsMixin) {
    private entityName: null | CmsEntityTypes = null;
    private loadingOverlay = new LoadingOverlayHelper(this, {});
    private backRoute: RouteNames = RouteNames.settings;
    private showArchived: boolean = false;
    private createNewUserEvent: EventBusEvents = EventBusEvents.createNewUserButton;
    private userHasRights: boolean = false;
    private currentTab: string = 'active';
    private CmsEntityTypes = CmsEntityTypes;
    private isLoading: boolean = false;

    private get currentEntityData() {
        return generateGivenEntityData(CmsEntityTypes.Users);
    }

    private get isAllowedToSearch() {
        return this.entityName === CmsEntityTypes.PostCodeConnections;
    }

    private get userGroups() {
        return UserGroupRepository.getAllWithClients();
    }

    private goToEntityIndex(newRouteConfiguration: NewRouteConfiguration) {
        openEntityIndex(newRouteConfiguration, this.entityName);
    }

    @Watch('$route', { deep: true, immediate: true })
    private async onRouteChange() {
        this.loadingOverlay.start();
        try {
            this.entityName = await setRouteEntity(this.$route);
        } catch {
            this.$router.push({ name: RouteNames.home });
            return;
        } finally {
            this.loadingOverlay.stop();
        }
    }

    private toggleFilter(e: any) {
        if (e.key === 'active') {
            this.showArchived = false;
        } else if (e.key === 'archived') {
            this.showArchived = true;
        }

        this.currentTab = e.key;
    }

    private created() {
        // @ts-ignore
        EventBus.$on(EventBusEvents.createNewUserButton, (payload: any) => {
            this.onCreateNew();
        });
        if (this.canViewUsersTab) {
            this.userHasRights = true;
        }

        UserGroup.getAllWithClients();
    }

    private async onCreateNew() {
        if (this.entityName == null) {
            return;
        }
        this.$router.push({
            name: RouteNames.cmsIndex,
            params: {
                entityName: this.entityName,
                entityId: 'new',
            },
        });
    }
}
